var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container page-area" },
    [
      _c(
        "q-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading"
            }
          ],
          staticClass: "page-area__card"
        },
        [
          _c(
            "q-card-section",
            { staticClass: "page-area__card-section" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "q-mb-lg page-area__top",
                  attrs: { align: "left" },
                  model: {
                    value: _vm.currentTab,
                    callback: function($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab"
                  }
                },
                [
                  _c("q-tab", { attrs: { name: "zoneForm", label: "Зона" } }),
                  _vm._v(" "),
                  _c("q-tab", {
                    attrs: { name: "intervalsForm", label: "Интервалы" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-area__content" },
                [
                  _c(
                    "q-form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "zoneForm",
                          expression: "currentTab === 'zoneForm'"
                        }
                      ],
                      ref: "zoneForm",
                      attrs: { greedy: "" }
                    },
                    [
                      _c("YMapArea", {
                        attrs: {
                          area: _vm.currentArea,
                          "other-areas": _vm.areas,
                          center: _vm.shop.coordinates,
                          placemark: {
                            hintContent: _vm.shop.address,
                            balloonContent:
                              "" +
                              [
                                _vm.shop.city,
                                _vm.shop.street,
                                _vm.shop.house
                              ].join(", "),
                            coordinates: _vm.shop.coordinates
                          }
                        },
                        on: { change: _vm.onYMapChange }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "q-form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "intervalsForm",
                          expression: "currentTab === 'intervalsForm'"
                        }
                      ],
                      ref: "intervalsForm",
                      attrs: { greedy: "" }
                    },
                    [
                      _c("Intervals", {
                        attrs: { intervals: _vm.intervals, min: 1 },
                        on: {
                          add: _vm.addInterval,
                          change: _vm.updateInterval,
                          remove: _vm.removeInterval
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right page-area__bottom" },
                [
                  _c("q-btn", {
                    attrs: { label: "Сохранить" },
                    on: { click: _vm.submit }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("q-inner-loading", { attrs: { showing: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }